import React from 'react'
import { Route, Routes } from 'react-router-dom'
import PrivateRoute7  from '../../app/routes/PrivateRoute7'

import ImportDataRegulationScreen from './ImportDataRegulationScreen'

const AdminDataRegulationRoutes = () => {
  return (
    <Routes>
        <Route path="/" element={<PrivateRoute7><ImportDataRegulationScreen /></PrivateRoute7>} />
        {/*<Route path="edit-catalog-roles" element={<PrivateRoute7><EditCatalogRoles /></PrivateRoute7>} />
        <Route path="new-catalog-roles" element={<PrivateRoute7><NewCatalogRoles /></PrivateRoute7>} />*/}
    </Routes>
  )
}

export default AdminDataRegulationRoutes